import currentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import TransferService from "../../services/TransferBetweenWarehouses";

import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import PictureAsPdfOutlinedIcon from "@material-ui/icons/PictureAsPdfOutlined";
import MyPdfViewerExitTape from "../../ui/MyPdfViewerExitTape";
import FileService from "../../services/FileService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../../utils/UtilsUrl";
import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import withLoader from "../../components/layouts/WithLoader";

const ReceiveTransfert = ({startLoading,stopLoading}) => {
  const [reference, setReference] = useState("");
  const [currrentWarehouse, setCurrrentWarehouse] = useState("");
  const [currrentTransfertData, setCurrrentTransfertData] = useState();
  const [transfertProducts, setTransfertProducts] = useState([]);

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [idUser, setIdUser] = useState(0);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [onShowExportButtom, setOnShowExportButtom] = useState(false);
  const [onShowExitTape, setOnShowExitTape] = useState(false);
  const [tape, setTape] = useState();
  const [pathFile, setPathFile] = useState(null);

  useEffect(() => {
    let useridd = currentUserId();
    setIdUser(useridd);
  }, []);

  useEffect(() => {
    console.log(transfertProducts);
    console.log(currrentWarehouse);
  }, [transfertProducts]);

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const onChangePOReferenceHandler = (event) => {
    setReference(event.target.value);
  };

  const onReceiveTransfertHandler = () => {

    if (reference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la réference est vide");
      setCurrrentWarehouse("");
      setTransfertProducts([]);
      setOnShowExportButtom(true);
    } else {
      startLoading();
      TransferService.getTransfertExistance(reference)
        .then((response) => {
          console.log("receiveTransfert", response);
          if (Object.keys(response.data)[0] === "ref_error") {
            if (
              idUser === response.data.ref_error[0].warehouseDestinationManager
            ) {
              setCurrrentTransfertData(response.data.ref_error[0]);
              TransferService.getWarehouseTransfertProducts(idUser, reference)
                .then((response) => {
                  if (Object.keys(response.data)[0] === "success") {
                    setCurrrentWarehouse("destinataire");
                    setTransfertProducts(response.data.success);
                  } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : il ya un erreur  ");
                    setCurrrentWarehouse("");
                    setTransfertProducts([]);
                    setOnShowExportButtom(false);
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                  setCurrrentWarehouse("");
                  setTransfertProducts([]);
                  setOnShowExportButtom(false);
                });
            } else {
              setCurrrentTransfertData(response.data.ref_error[0]);
              TransferService.getWarehouseTransfertProducts(idUser, reference)
                .then((response) => {
                  if (Object.keys(response.data)[0] === "success") {
                    setCurrrentWarehouse("source");
                    setTransfertProducts(response.data.success);
                  } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : il ya un erreur  ");
                    setCurrrentWarehouse("");
                    setTransfertProducts([]);
                    setOnShowExportButtom(false);
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                  setCurrrentWarehouse("");
                  setTransfertProducts([]);
                  setOnShowExportButtom(false);
                });
            }
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : ce reférence n'existe pas");
            setCurrrentWarehouse("");
            setTransfertProducts([]);
            setOnShowExportButtom(false);
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : "+error);
          setCurrrentWarehouse("");
          setTransfertProducts([]);
          setOnShowExportButtom(false);
        }).finally(() => {
          stopLoading();
        });
    }
  };

  const onFinishTransfertOperation = () => {
    startLoading();
    TransferService.transfertProcessingByWarehouseManager(idUser, reference)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Succés :operation terminée");
          setOnShowExportButtom(true);
        } else if (Object.keys(response.data)[0] === "roleError") {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :tu n'a pas le droit de faire ce mission");
          setCurrrentWarehouse("");
          setTransfertProducts([]);
        } else if (Object.keys(response.data)[0] === "notFoundError") {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :ce transfert n'existe pas ");
          setCurrrentWarehouse("");
          setTransfertProducts([]);
        } else if (Object.keys(response.data)[0] === "WrongTargetError") {
          setOpenErrorAlert(true);
          setErrorAlertText(
            "Erreur : ce dépot ne correspond pas a ce transfert "
          );
          setCurrrentWarehouse("");
          setTransfertProducts([]);
        } else if (Object.keys(response.data)[0] === "missionWasDoneError") {
          setOpenInfoAlert(true);
          setInfoAlertText("Erreur :ce mission est déja fait");
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :au niveau de serveur ");
          setCurrrentWarehouse("");
          setTransfertProducts([]);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error);
        setCurrrentWarehouse("");
        setTransfertProducts([]);
      }).finally(() => {
        stopLoading();
      });;
  };

  const onExportPdfExitTape = () => {
    var myTapeModel = {
      title: "",
      id: currrentTransfertData.id,
      reference: reference,
      destination: currrentTransfertData.warehouseDestinationName,
      source: currrentTransfertData.warehouseSourceName,
      trans_date: new Date().toISOString().slice(0, 10),
      items: [],
    };

    transfertProducts.map((ele, i) => {
      let element = {};

      element["name"] = ele.name;
      element["productCode"] = ele.productCode;

      element["qty"] = ele.quantity;
      myTapeModel.items.push(element);
    });
    if (currrentWarehouse === "source") {
      myTapeModel.title = "Bon de Sortie";
    } else {
      myTapeModel.title = "Bon de reception";
    }

    setTape(myTapeModel);

    setOnShowExitTape(true);
  };
  const columns = [
    {
      dataField: "name",
      text: "Libellé",
      headerAlign: "center",
    },

    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];
  function handleTableChange({ transfertProducts }) {
    return transfertProducts;
  }
  const onShowFileInOtherWindowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const onUploadFileHandler = (refTransfert, type) => {
    FileService.generateBonTransfert(
      getCurrentUserId(),
      refTransfert,
      type
    ).then((response) => {
      if (response.data["success"]) {
        setPathFile(response.data["success"]);
        onShowFileInOtherWindowHandler(
          UtilsUrl.fileRetailURL() + response.data["success"]
        );
      }
    });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header"></section>{" "}
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-header  ">
                  <h3 class="card-title">
                    Recevoir un transfert de la part d'un transporteur
                  </h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-12">
                      <label>Taper la réference de transfert</label>
                      <input
                        onChange={onChangePOReferenceHandler}
                        type="text"
                        required
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onReceiveTransfertHandler}
                    >
                      Recevoir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {transfertProducts.length > 0 && (
        <section className="content ">
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">
                  {(() => {
                    if (currrentWarehouse === "source")
                      return (
                        <span>
                          Votre mission et de faire servir les produits suivants
                          :{" "}
                        </span>
                      );
                    if (currrentWarehouse === "destinataire")
                      return (
                        <span>
                          Votre mission et de faire recevoir les produits
                          suivants :{" "}
                        </span>
                      );
                  })()}{" "}
                </h3>
              </div>
              <div className="card-body">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <ToolkitProvider
                        keyField="idProduct"
                        data={transfertProducts}
                        columns={columns}
                        onTableChange={handleTableChange}
                      >
                        {(props) => (
                          <div className="row">
                            <BootstrapTable
                              {...props.baseProps}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>

                <div className="form-group" class=" col-2 col-sm-12">
                  {(() => {
                    if (
                      currrentWarehouse === "source" ||
                      currrentWarehouse === "destinataire"
                    )
                      return (
                        <button
                          className="btn btn-dark float-right"
                          onClick={onFinishTransfertOperation}
                        >
                          Terminer
                        </button>
                      );

                    if (currrentWarehouse === "source" && onShowExportButtom)
                      return (
                        <button
                          className="btn btn-dark "
                          onClick={onFinishTransfertOperation}
                        >
                          <PictureAsPdfOutlinedIcon />
                          Bon de sortie
                        </button>
                      );

                    if (
                      currrentWarehouse === "destinataire" &&
                      onShowExportButtom
                    )
                      return (
                        <button
                          className="btn btn-dark "
                          onClick={onFinishTransfertOperation}
                        >
                          <PictureAsPdfOutlinedIcon />
                          Bon de Réception
                        </button>
                      );
                  })()}

                  {(() => {
                    if (currrentWarehouse === "source" && onShowExportButtom)
                      return (
                        <button
                          className="btn btn-dark "
                          onClick={() => {
                            onUploadFileHandler(reference, 0);
                          }}
                        >
                          <PictureAsPdfOutlinedIcon />
                          Bon de sortie
                        </button>
                      );

                    if (
                      currrentWarehouse === "destinataire" &&
                      onShowExportButtom
                    )
                      return (
                        <button
                          className="btn btn-dark "
                          onClick={() => {
                            onUploadFileHandler(reference, 1);
                          }}
                        >
                          <PictureAsPdfOutlinedIcon />
                          Bon de réception
                        </button>
                      );
                  })()}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={2000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onShowExitTape && (
        <MyPdfViewerExitTape
          tape={tape}
          setOnShowExitTape={setOnShowExitTape}
        ></MyPdfViewerExitTape>
      )}
    </div>
  );
};
export default withLoader(ReceiveTransfert);
